import Vue from 'vue'
import TimeLineTest from "../components/TimeLineTest.vue"
import TimeLineResult from "../components/TimeLineResult.vue"
export default (): void => {
  Vue.component('time-line-test', TimeLineTest)
  Vue.component('time-line-result', TimeLineResult)
}
